import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { SolutionSection } from '../components/SolutionSection';
import { TestimonialSection } from '../components/TestimonialSection';
import { IncludedSection } from '../components/IncludedSection';
import { TargetAudience } from '../components/TargetAudience';
import { StepsSection } from '../components/StepsSection';
import { FAQSection } from '../components/FAQSection';
import { PricingCTA } from '../components/PricingCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full overflow-hidden" data-id="element-241">
      <HeroSection data-id="element-242" />
      <PainSection data-id="element-243" />
      <FailedSolutions data-id="element-244" />
      <SolutionSection data-id="element-245" />
      <TestimonialSection data-id="element-246" />
      <IncludedSection data-id="element-247" />
      <TargetAudience data-id="element-248" />
      <StepsSection data-id="element-249" />
      <FAQSection data-id="element-250" />
      <PricingCTA data-id="element-251" />
      <Footer data-id="element-252" />
    </main>;
}